import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-3daf926c")
const _hoisted_1 = { id: "scroll-bar-component" }
const _hoisted_2 = {
  id: "scroll-bar-vertical",
  ref: "scrollBarVertical"
}
const _hoisted_3 = {
  id: "scroll-bar-horizontal",
  ref: "scrollBarHorizontal"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { id: "scroll-bar-end" }, null, -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        id: "scroller-vertical",
        ref: "scrollerVertical",
        onMousedown: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleMouseDownScrollY && _ctx.handleMouseDownScrollY(...args)))
      }, null, 544)
    ], 512),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        id: "scroller-horizontal",
        ref: "scrollerHorizontal",
        onMousedown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleMouseDownScrollX && _ctx.handleMouseDownScrollX(...args)))
      }, null, 544)
    ], 512),
    _hoisted_4
  ]))
}